import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Switch from "@mui/material/Switch";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import SubscriberGroupBoxPlot from "./SubscriberGroupBoxPlot";

const Wrapper = styled.div`
  margin: 30px 20px 0 20px;
`;

const WrapperTotalColorize = styled.div`
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
`;

const WrapperSwitch = styled.div`
  display: flex;
  align-items: center;
  .sw-input.MuiSwitch-root {
    & .Mui-checked {
      color: var(--switch-checked-green);
    }

    & .Mui-checked + .MuiSwitch-track {
      background-color: var(--switch-checked-light-green);
    }
  }
`;

const TotalSubscribers = styled.h4`
  font-size: 16px !important;
  font-weight: 100 !important;
  color: var(--text-primary) !important;
  margin-right: 20px;
`;

const CenteredMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 100%;
  min-height: 25px;
  margin-bottom: 30px;
`;

const NoEnoughtData = () => (
  <CenteredMessage>Not enough data to display box plots.</CenteredMessage>
);

const BOXPLOT_METRICS_ORDER_MAP = {
  "MEAN-Mbps": 0,
  "SUBS-ACTIVE": 1,
  "RTT-ms": 2,
  RTX: 3,
  CONGEST: 4,
};

const Statistics = ({
  data,
  thresholds,
  setThresholds,
  colorize,
  setColorize,
}) => {
  const statisticsMetrics = Object.entries(data)
    .filter(([key, value]) => {
      return key !== "totalGroups" && key !== "newRows" && key !== "names" && key !== 'rows';
    })
    .sort(
      (a, b) =>
        BOXPLOT_METRICS_ORDER_MAP[a[0]] - BOXPLOT_METRICS_ORDER_MAP[b[0]]
    );

  const handleUpdateThresholds = (metric, value) => {
    const cmd = `configure\npkteng\nmetrics threshold ${metric.toLowerCase()} ${value}\ncommit\n`;
    ifCl
      .run(cmd, true)
      .then(() => setThresholds({ ...thresholds, [metric]: value }))
      .catch((error) => showModalError("Error:", error));
  };

  return (
    <Wrapper>
      <WrapperTotalColorize>
        <TotalSubscribers className="total-subscribers-label">
          {data.totalGroups} Groups
        </TotalSubscribers>
        <WrapperSwitch>
          <div>
            {!colorize
              ? "Colorize: by warning threshold"
              : "Colorize: by quartiles"}
          </div>
          <Switch
            className="sw-input"
            checked={colorize}
            onChange={() => setColorize(!colorize)}
          />
        </WrapperSwitch>
      </WrapperTotalColorize>
      {data.totalGroups < 2 ? (
        <NoEnoughtData />
      ) : (
        <ColumnsGrid
          columns={statisticsMetrics.length}
          minWidth="5cm"
          gap={"2em"}
          className="box-plot-container"
          rowGap="0"
        >
          {statisticsMetrics.map(([key, values]) => {
            return (
              <SubscriberGroupBoxPlot
                metric={key}
                data={values}
                threshold={thresholds[key]}
                updateThresholds={handleUpdateThresholds}
                colorize={colorize}
                key={`box-plot-${key}`}
              />
            );
          })}
        </ColumnsGrid>
      )}
    </Wrapper>
  );
};

export default Statistics;
